import { Injectable } from '@angular/core';
import { Subject, pipe } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';

import { CacheService, Preferences } from '@library/core';
import { HttpPagination, ResponseWrapper } from '@library/common/http';
import { Filter } from '@library/modules/sidebar';
import { QuotationSnapshot } from '@library/modules/quotation';

@Injectable({
  providedIn: 'root'
})
export class QuotationSnapshotService {

  public reset$: Subject<void> = new Subject();
  public refresh$: Subject<void> = new Subject();


  public sort_types = [
    {
      field: 'fwq',
      name: 'Request',
    },
    {
      field: 'createdDate',
      name: 'Create Date',
    },
    {
      field: 'validToDate',
      name: 'Validity Date',
    },
    {
      field: 'serviceLevel',
      name: 'Service Level',
    },
    {
      field: 'cost',
      name: 'Cost',
    },
  ];

  public get sort_type() {
    return this.prefs.getPref('quoteSnap.sort_type');
  }

  public get sort_asc() { return this.prefs.getPref( 'quoteSnap.sort_asc' ) || false; }
  
  public set sort_asc( value ) {
    this.prefs.upsertPref( 'quoteSnap.sort_asc', value );
    this.refresh$.next();
  }

  public set sort_type( value ) {
    this.prefs.upsertPref( 'quoteSnap.sort_type', value );
    this.refresh$.next();
  }

  url = 'quotations/list';
  destroy$: Subject<boolean> = new Subject();
  filters: Filter<QuotationSnapshot>[] = [];

  constructor (
    private prefs: Preferences,
    private cache: CacheService,
    // private reqData: CacheRequestService,
    private pagination: HttpPagination,
  ) { }

  list$() {
    return this.cache.request<ResponseWrapper<QuotationSnapshot>, QuotationSnapshot[]>({
      url: this.url,
      params: {},
      refresher: this.refresh$,
      pipe: pipe(
        map( rw => rw.response.collection ),
        takeUntil(this.destroy$)
      ),
      useLambda: true,
    })
    .pipe(
      map( list => list.map( i => new QuotationSnapshot( i ))),
    );
  }

  sort( list: QuotationSnapshot[] ): QuotationSnapshot[] {
    if ( !list.length ) { return list; }

    let sorted = [];

    switch ( this.sort_type ) {
        case 'fwq':
          sorted = list.sort( ( a, b ) => +b.fwq - +a.fwq );
          break;
        case 'serviceLevel':
          sorted = list.sort( ( a, b ) => b.serviceLevel.localeCompare( a.serviceLevel ));
          break;
        case 'cost':
          sorted = list.sort(( a, b ) => (+b.cost - +a.cost));
          break;
        case 'validToDate':
          sorted = list.sort((a, b) => {
            const dateA = a.validToDate ? new Date(a.validToDate).getTime() : 0; // Assign 0 for empty dates
            const dateB = b.validToDate ? new Date(b.validToDate).getTime() : 0;
            return dateB - dateA; // Descending order
          });
          break;
        case 'createdDate':
        default:
          sorted = list.sort( ( a, b ) => (b.datetime - a.datetime) );
    }

    return this.sort_asc ? sorted.reverse() : sorted;
  }

  stop() {
    console.warn( 'Defunct stop function called' );
  }

  start() {
    this.reset();
  }

  reset(): void {
    this.filters = [];
    this.reset$.next();
    this.cache.cancelPagination( this.pagination.hash );
    this.pagination.reset();
 }

}
